<nz-modal
  nzWrapClassName="form-modal"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  [nzWidth]="'65%'"
  (nzOnCancel)="onCloseModal(false)"></nz-modal>


<ng-template #modalTitle>
  <div class="container-steps-modal" [@fadeInAnimation]>
    <h2 class="text-title-md-bold title-modal">{{ clinicBranch?._id ? 'Actualizar sucursal' : 'Nueva sucursal' }}</h2>
    <p class="text-info mt-xxs">{{ clinicBranch?._id ? 'Se actualizará la sucursal' : 'Se agregará una nueva sucursal a la clínica' }}</p>
  </div>
</ng-template>


<ng-template #modalContent>
  <div class="container-modal shepherd-branch-modal" [@fadeInAnimation]>
    <div nz-row>
      <div nz-col class="mb-md text-subtitle-bold-upper">
        <p>Información básica</p>
      </div>
    </div>

    <form #clinicBranchForm="ngForm">
      <div nz-row nzGutter="16">
        <div nz-col nzXs="24" nzSm="8" nzLg="6" class="mb-sm shepherd-branch-modal-name">
          <div class="input-label-form">Nombre de la sucursal</div>
          <input nz-input [required]="true" [(ngModel)]="clinicBranch.name" #ngName="ngModel" name="name" placeHolder="Nombre de la sucursal">
          <app-message-field [field]="ngName"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" nzLg="6" class="mb-sm shepherd-branch-modal-email">
          <div class="input-label-form">Correo electrónico</div>
          <input nz-input [required]="true" placeholder="Correo electrónico de la sucursal" [(ngModel)]="clinicBranch.email" #ngEmail="ngModel"
            name="email" nz-input type="email" (ngModelChange)="helperValidationField.onValidateEmail(clinicBranch.email, ngEmail)">
          <app-message-field [field]="ngEmail"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" nzLg="6" class="mb-sm shepherd-branch-modal-timezone">
          <div class="input-label-form">Zona horaria</div>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Zona horaria" [required]="true" [(ngModel)]="clinicBranch.timeZone" #ngCountry="ngModel"
            name="timeZone">
            <nz-option *ngFor="let timeZone of this.timeZones;" [nzLabel]="timeZone" [nzValue]="timeZone"></nz-option>
          </nz-select>
          <app-message-field [field]="ngCountry"></app-message-field>
        </div>

        <div nz-col nzXs="24" nzSm="8" nzLg="6" class="mb-sm shepherd-branch-modal-schedule">
          <div class="input-label-form">Grupo de horarios por defecto</div>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Grupo de horarios" [required]="true" [(ngModel)]="clinicBranch.scheduleGroupId"
            #ngScheduleGroupId="ngModel" name="scheduleGroupId">
            <nz-option *ngFor="let group of (scheduleGroups$ | async);" [nzLabel]="group.name" [nzValue]="group._id"></nz-option>
          </nz-select>
          <app-message-field [field]="ngScheduleGroupId"></app-message-field>
        </div>
      </div>
    </form>

    <nz-divider nzPlain></nz-divider>

    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="16">
        <app-address-section
          class="shepherd-branch-modal-address"
          [address]="this.clinicBranch.address"
          [removeClassCardContainerShadow]="true"></app-address-section>
      </div>
      <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="8">
        <app-phones
          class="shepherd-branch-modal-phone"
          [phones]="this.clinicBranch.phones"
          [removeClassCardContainerShadow]="true"></app-phones>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalFooter>
  <div class="container-footer-modal" [@fadeInAnimation]>
    <button
      style="margin-right: 5px;"
      (click)="onCloseModal(false)"
      nz-button nzType="cancel">
      <i nz-icon nzType="close-circle" nzTheme="outline"></i>
      CANCELAR</button>
    <button
      class="shepherd-branch-modal-btn-add"
      (click)="onCloseModal(true)"
      nz-button nzType="primary">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      {{ this.clinicBranch._id ? 'Actualizar sucursal' : 'Crear sucursal' }}</button>
  </div>
</ng-template>
